export type SelectedTag = {
  tagId: string;
  groupId?: string;
  isAuto?: boolean;
}

export class CallEvaluation {
  readonly tags: SelectedTag[] = [];
  readonly savedAt?: Date;
  readonly comment: string = "";
  readonly reconnectDate?: Date;

  /**
   * Whether the "later" section is visible in ReconnectTimeSection.
   */
  readonly reconnectIsLaterSectionVisible: boolean = false;

  /**
   * Selected index in ReconnectTimeSection.
   */
  readonly reconnectTimeIndex: number = 0;

  /**
   * Whether evaluation was saved automatically and how.
   */
  readonly evaluationAuto?: 'offer';

  constructor(deriveFrom?: Partial<CallEvaluation>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    //  Limit to one per tagId.
    this.tags = this.tags.reduce((tags, reference) => {
      if (tags.find(otherRef => otherRef.tagId === reference.tagId)) {
        return tags;
      }

      return [...tags, reference];
    }, [] as SelectedTag[]);
  }
}